import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

const inputCls = "bg-surface-2/60 border-metallic text-white placeholder:text-slate-500";

export default function ContactForm({ onDone }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", form);
      toast.success("Tack för ditt meddelande! Vi hör av oss så snart vi kan.");
      setForm({ name: "", email: "", phone: "", message: "" });
      onDone?.();
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="contact-name" className="text-slate-300">Namn *</Label>
          <Input
            id="contact-name"
            data-testid="contact-name-input"
            required
            value={form.name}
            onChange={(e) => set("name", e.target.value)}
            placeholder="Ditt namn"
            className={inputCls}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="contact-phone" className="text-slate-300">Telefon</Label>
          <Input
            id="contact-phone"
            data-testid="contact-phone-input"
            value={form.phone}
            onChange={(e) => set("phone", e.target.value)}
            placeholder="07X-XXX XX XX"
            className={inputCls}
          />
        </div>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="contact-email" className="text-slate-300">E-post *</Label>
        <Input
          id="contact-email"
          data-testid="contact-email-input"
          type="email"
          required
          value={form.email}
          onChange={(e) => set("email", e.target.value)}
          placeholder="din@epost.se"
          className={inputCls}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="contact-message" className="text-slate-300">Meddelande *</Label>
        <Textarea
          id="contact-message"
          data-testid="contact-message-input"
          required
          rows={5}
          value={form.message}
          onChange={(e) => set("message", e.target.value)}
          placeholder="Skriv ditt meddelande här..."
          className={inputCls}
        />
      </div>
      <Button
        type="submit"
        data-testid="contact-submit-button"
        disabled={sending}
        className="w-full rounded-full bg-brand hover:bg-brand-dark text-white font-semibold py-3"
      >
        <Send size={16} className="mr-2" />
        {sending ? "Skickar..." : "Skicka meddelande"}
      </Button>
    </form>
  );
}
